import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { SgOidcLogin } from '@sg/auth/oidc/src';

@Injectable()
export class SgCanActivateUserGroupGuard implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedUserGroups: string[] = route.data.userGroups as string[];

    let userGroups: string[] = [];
    try {
      const oidcLogin = SgOidcLogin.get();
      if (oidcLogin?.userProfile?.groups) {
        userGroups = oidcLogin.userProfile.groups.split(',').map((group) => group.trim());
      }
    } catch (error) {
      console.warn('OIDC not initialized in route guard:', error.message);
      return false;
    }

    let canActivateRoute = false;

    userGroups.forEach((group) => {
      const isAllowedGroup = allowedUserGroups.includes(group);
      if (isAllowedGroup) {
        canActivateRoute = true;
      }
    });

    return canActivateRoute;
  }
}
